import { z } from 'zod';

export const DepartmentsScalarFieldEnumSchema = z.enum(['departmentId','cityId','name','assignToId','managerId','expectCloseDays','notifyId','defaultTopicFilterId','parentDepartmentId','rowTimestamp']);

export default DepartmentsScalarFieldEnumSchema;
